import React from 'react'
import clsx from 'clsx'

import { Image } from '@/components/atoms/Image/Image'
import { Paragraph } from '@/components/atoms/MarkdownElements/MarkdownElements'
import { PersonComponentType, PersonType } from './Person.types'
import * as styles from './Person.module.css'

export function Person({ image, name, role, description, componentType }: PersonType) {
  const WrapperComponent = componentType === PersonComponentType.Quote ? 'blockquote' : 'div'
  const DetailsComponent = componentType === PersonComponentType.Quote ? 'cite' : 'div'

  return (
    <WrapperComponent className={clsx(styles.wrapper, 'mb-40 flex flex-col items-center')}>
      <div className={clsx(styles.image, componentType === PersonComponentType.Quote && styles.roundedImage)}>
        <Image fluid fixed={false} options={{ width: 250, maxWidth: 400 }} data={image} />
      </div>
      {description && (
        <Paragraph className="mt-40 mb-20 text-center font-sans font-normal text-bodyL">{description}</Paragraph>
      )}
      <DetailsComponent className={clsx(styles.details, 'not-italic text-text-dark-900')}>
        <p className={clsx(description ? 'text-headingM-mobile' : null, 'mt-20 font-bold text-center font-poppins')}>
          {name}
        </p>
        <p className={clsx(description ? 'text-bodyL font-sans' : 'font-bold text-bodyM font-poppins', 'text-center')}>
          {role}
        </p>
      </DetailsComponent>
    </WrapperComponent>
  )
}
